<template>
  <div class="carousel_wrap">
    <el-carousel :interval="5000" height="42vw" loop arrow="never" class="hidden-xs-only hero_carousel">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div class="hero_slide">
          <img :src="item.src" alt="" class="img_item" />
          <div class="hero_backdrop"></div>
          <div class="hero_shell">
            <div class="hero_content">
              <div class="hero_eyebrow">{{ item.kicker }}</div>
              <div class="hero_brand">{{ $t('company.name') }}</div>
              <div class="hero_title_group">
                <h1>{{ item.line1 }}</h1>
                <h1>{{ item.line2 }}</h1>
              </div>
              <p class="hero_desc">{{ item.description }}</p>
              <div class="hero_metrics">
                <div v-for="metric in item.metrics" :key="metric.label" class="metric_item">
                  <strong>{{ metric.value }}</strong>
                  <span>{{ metric.label }}</span>
                </div>
              </div>
            </div>

            <div class="hero_note">
              <p>{{ $t('company.tagline') }}</p>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <el-carousel height="94vw" loop arrow="never" class="hidden-sm-and-up hero_carousel mobile_carousel">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div class="hero_slide">
          <img :src="item.src" alt="" class="img_item" />
          <div class="hero_backdrop"></div>
          <div class="hero_mobile_shell">
            <div class="hero_eyebrow">{{ item.kicker }}</div>
            <div class="hero_brand">{{ $t('company.name') }}</div>
            <div class="hero_title_group">
              <h1>{{ item.line1 }}</h1>
              <h1>{{ item.line2 }}</h1>
            </div>
            <p class="hero_desc">{{ item.description }}</p>
            <div class="hero_metrics mobile_metrics">
              <div v-for="metric in item.metrics" :key="metric.label" class="metric_item">
                <strong>{{ metric.value }}</strong>
                <span>{{ metric.label }}</span>
              </div>
            </div>
            <div class="hero_note mobile_note">
              <p>{{ $t('company.tagline') }}</p>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  computed: {
    imgList() {
      const items = this.$t('home.carousel.items', { returnObjects: true })
      return [
        {
          src: require('@/assets/img/banner1.jpg'),
          ...items[0],
          line1: this.$t('home.banner.title1'),
          line2: this.$t('home.banner.title2'),
        },
        {
          src: require('@/assets/img/banner2.jpg'),
          ...items[1],
          line1: this.$t('home.banner.subtitle1'),
          line2: this.$t('home.banner.subtitle2'),
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.carousel_wrap {
  --hero-nav-offset: 44px;
  position: relative;
  overflow: hidden;

  .hero_carousel {
    .el-carousel__container {
      display: grid;
      height: auto !important;
      min-height: 620px;
    }

    .el-carousel__item {
      position: relative;
      grid-area: 1 / 1;
      height: auto;
    }

    .el-carousel__indicators {
      bottom: 30px;
    }

    .el-carousel__button {
      width: 26px;
      height: 3px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.4);
    }
  }
}

.hero_slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.img_item {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero_backdrop {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(5, 14, 30, 0.82) 0%, rgba(5, 14, 30, 0.58) 38%, rgba(5, 14, 30, 0.16) 76%),
    linear-gradient(180deg, rgba(5, 14, 30, 0.08) 0%, rgba(5, 14, 30, 0.42) 100%);
}

.hero_shell {
  position: relative;
  min-height: max(42vw, 620px);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(96px + var(--hero-nav-offset)) 8vw 72px;
  text-align: center;
}

.hero_content {
  color: #ffffff;
}

.hero_eyebrow {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin: 0 auto 14px;
  padding: 6px 11px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(220, 252, 231, 0.94);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.hero_brand {
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.92);
  font-size: clamp(30px, 3vw, 44px);
  font-weight: 700;
  letter-spacing: 0.02em;
}

.hero_title_group {
  margin: 0 auto;

  h1 {
    margin: 0;
    font-family: "Avenir Next", "Segoe UI Variable", "PingFang SC", sans-serif;
    font-size: clamp(22px, 2.4vw, 34px);
    font-weight: 600;
    line-height: 1.12;
    letter-spacing: -0.02em;
    text-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
  }

  h1 + h1 {
    margin-top: 4px;
  }
}

.hero_desc {
  max-width: 520px;
  margin: 14px auto 0;
  color: rgba(241, 245, 249, 0.84);
  font-size: 12px;
  line-height: 1.7;
}

.hero_metrics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 18px;
}

.metric_item {
  min-width: 92px;
  padding: 9px 12px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;

  strong {
    display: block;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
  }

  span {
    display: block;
    margin-top: 5px;
    color: rgba(226, 232, 240, 0.72);
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
}

.hero_note {
  width: fit-content;
  margin: 18px auto 0;
  padding: 0;
  background: transparent;

  p {
    margin: 0;
    color: rgba(248, 250, 252, 0.72);
    font-size: 12px;
    line-height: 1.6;
    letter-spacing: 0.04em;
  }
}

.hero_mobile_shell {
  position: relative;
  min-height: 540px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(78px + var(--hero-nav-offset)) 20px 56px;
  color: #ffffff;
  text-align: center;

  .hero_brand {
    margin-bottom: 12px;
    font-size: 28px;
  }

  .hero_title_group h1 {
    font-size: clamp(20px, 6vw, 28px);
  }

  .hero_desc {
    max-width: 100%;
    margin-top: 12px;
    font-size: 12px;
  }
}

.mobile_metrics {
  gap: 8px;
  margin-top: 16px;
  justify-content: center;

  .metric_item {
    min-width: 84px;
    padding: 9px 10px 10px;
  }
}

.mobile_note {
  margin-top: 16px;
  padding: 0;
  margin-left: auto;
  margin-right: auto;

  p {
    font-size: 12px;
    line-height: 1.6;
  }
}

@media screen and (max-width: 1200px) {
  .hero_shell {
    padding-left: 6vw;
    padding-right: 6vw;
  }
}

@media screen and (max-width: 768px) {
  .carousel_wrap {
    --hero-nav-offset: 28px;
  }

  .carousel_wrap {
    .mobile_carousel {
      .el-carousel__container {
        min-height: 540px;
      }

      .el-carousel__indicators {
        bottom: 18px;
      }
    }
  }

  .hero_mobile_shell {
    padding: calc(96px + 28px) 20px 56px;

    .hero_eyebrow {
      margin-bottom: 12px;
      padding: 6px 11px;
      font-size: 12px;
    }

    .hero_brand {
      margin-bottom: 12px;
      font-size: 28px;
    }

    .hero_title_group h1 {
      font-size: 26px;
      line-height: 1.18;
    }

    .hero_desc {
      margin-top: 12px;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .mobile_metrics {
    gap: 8px;
    margin-top: 16px;

    .metric_item {
      min-width: 84px;
      padding: 9px 10px 10px;

      strong {
        font-size: 14px;
      }

      span {
        margin-top: 5px;
        font-size: 12px;
      }
    }
  }

  .mobile_note {
    margin-top: 16px;

    p {
      font-size: 12px;
      line-height: 1.6;
    }
  }
}
</style>
